"use client";

import type { NavLink } from "@/components/landing/types";
import { MotionReveal, useSectionMotion } from "@/components/landing/shared";
import { Logo } from "@/components/Logo";
import { Link } from "@/i18n/navigation";

function FooterInner({
	tagline,
	nav,
	legal = [],
}: {
	tagline: string;
	nav: NavLink[];
	legal?: NavLink[];
}) {
	const motion = useSectionMotion();
	const year = new Date().getFullYear();
	return (
		<MotionReveal
			motion={motion}
			className="mx-auto flex max-w-6xl flex-col items-center gap-4 px-6 text-center"
		>
			<div className="flex flex-col items-center gap-2.5">
				<Link href="/">
					<Logo className="h-8 w-auto text-foreground" />
				</Link>
				<p className="max-w-md text-sm text-muted-foreground">{tagline}</p>
			</div>
			{nav.length > 0 && (
				<nav
					aria-label="Footer"
					className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm text-muted-foreground"
				>
					{nav.map((n) => (
						<a key={n.href} href={n.href} className="hover:text-text">
							{n.label}
						</a>
					))}
				</nav>
			)}
			{legal.length > 0 && (
				<nav
					aria-label="Legal"
					className="flex flex-wrap justify-center gap-x-4 gap-y-1 text-xs text-muted-foreground"
				>
					{legal.map((n) => (
						<a
							key={n.href}
							href={n.href}
							className="underline-offset-4 hover:text-text hover:underline"
						>
							{n.label}
						</a>
					))}
				</nav>
			)}
			<p className="text-xs text-muted-foreground">©{year} Jana</p>
		</MotionReveal>
	);
}

export default FooterInner;
